function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { hasOwnProperty } from "../utils";

var InputDeferDecorator = /*#__PURE__*/function () {
  function InputDeferDecorator(target) {
    _classCallCheck(this, InputDeferDecorator);

    _defineProperty(this, "pendingInput", {});

    _defineProperty(this, "target", void 0);

    this.target = target;
  }

  _createClass(InputDeferDecorator, [{
    key: "setInput",
    value: function setInput(nameType, value, opts) {
      if (/^\./.test(nameType)) this.target.setInput(nameType, value, opts);else this.pendingInput[nameType] = {
        value: value,
        opts: opts
      };
    }
  }, {
    key: "submit",
    value: function submit() {
      for (var nameType in this.pendingInput) {
        if (hasOwnProperty(this.pendingInput, nameType)) {
          var _this$pendingInput$na = this.pendingInput[nameType],
              value = _this$pendingInput$na.value,
              opts = _this$pendingInput$na.opts;
          this.target.setInput(nameType, value, opts);
        }
      }
    }
  }]);

  return InputDeferDecorator;
}();

export { InputDeferDecorator };